import { Calendar, InputAddBooking, InputUpdateColorDiary, InputUpdateBooking } from "@okeys/shared-react-components"
import { Service } from "@okeys/shared-utils"
import { useBookingAddMutation, useBookingCancellationMutation } from "@/query/bookingQuery"
import { useCalendarProps } from "./hooks/useCalendarProps"

export const Schedules = () => {
  const { diaries, clients, services, isPending, isError } = useCalendarProps()
  const cancelBookingMutation = useBookingCancellationMutation()
  const addBookingMutation = useBookingAddMutation()

  const handleDelReservation = (bookingId: string) => {
    // Confirmation avant suppression
    cancelBookingMutation.mutate({ bookingId, message: "Annulation par le manager" })
  }

  const handleAddBooking = (booking: InputAddBooking) => {
    const bookingData = {
      scheduledStart: booking.scheduledStart,
      scheduledEnd: booking.scheduledEnd,
      services: (booking as any).services || [],
      clientId: booking.clientId ?? null,
      prestatereId: booking.prestatereId,
      shopId: "", // déduit côté backend via token si nécessaire
    }
    addBookingMutation.mutate(bookingData)
  }

  const handleUpdateColorDiary = (input: InputUpdateColorDiary) => {
    console.log("input", input)
  }

  const handleUpdateBooking = (booking: InputUpdateBooking) => {
    console.log("booking : ", booking)
  }

  if (isPending) return <div>Loading...</div>
  if (isError) return <div>Une erreur est survenue</div>

  return (
    <div className="h-full w-full">
      <Calendar
        diaries={diaries}
        clients={clients}
        services={services as Service<"beauty">[] | undefined}
        onDelBooking={handleDelReservation}
        onAddBooking={handleAddBooking}
        onUpdateColorDiary={handleUpdateColorDiary}
        onUpdateBooking={handleUpdateBooking}
      />
    </div>
  )
}
